import { useMemo } from 'react';
import { useLocation } from 'quartz-routing/react-router';
import { STRATEGY_TYPES } from 'personalization-lib/constants/strategyType';
import usePersonalizationStrategy from 'personalization-lib/hooks/variants/usePersonalizationStrategy';
import { createPersonalizationSearchString, getPersonalizationQueryParams } from 'personalization-lib/utils/urls/queryParams';
import { getPersonalizationUrl, getVariantsEditorUrl } from 'personalization-lib/utils/urls';
const useBackToPersonalizationUrl = strategyId => {
  const {
    search: currentSearch
  } = useLocation();
  const currentQueryParams = useMemo(() => getPersonalizationQueryParams(currentSearch), [currentSearch]);
  const isStrategyIdValid = !!strategyId && strategyId === currentQueryParams.strategyId;
  const {
    strategy
  } = usePersonalizationStrategy(isStrategyIdValid ? strategyId : undefined);
  if (!isStrategyIdValid) return undefined;
  if ((strategy === null || strategy === void 0 ? void 0 : strategy.strategyType) !== STRATEGY_TYPES.SMART_PAGE) {
    return getPersonalizationUrl();
  }
  return getVariantsEditorUrl(strategyId, {
    search: createPersonalizationSearchString({
      fromCreate: currentQueryParams.fromCreate
    })
  });
};
export default useBackToPersonalizationUrl;